export default "__VITE_ASSET__OFtS6KvC__"